import { HStack, Text } from '@digital-retail/design-system';
import { ChevronLeftIcon, ChevronRightIcon } from '@digital-retail/design-system-icons';
import { isTottusStandalone, isWhitelabel } from '@digital-retail/store-manager';
import { cx } from 'cvb';
import Router from 'next/router';
import PropTypes from 'prop-types';
import { constants } from '../../config/constants';
import { storeMap } from '../../config/storeMap';
import { WebStorage } from '../../utils/WebStorage';
import { noop } from '../../utils/noop';
import { replacePathsToStandalonePaths } from '../../utils/store.helpers';
import { resetDigitalData } from '../Facets/Common/digitalData';
import { styles } from './Pagination.style';

const Pagination = ({
  getPaginatedUrl,
  resultsPerPage,
  totalResults,
  currentPage,
  section,
  tenant,
  setBusy,
  pageName,
  setStopScroll,
  store,
}) => {
  const totalPages = Math.ceil(totalResults / resultsPerPage);
  const onPageSelection = (url) => {
    WebStorage.setItem({
      name: constants.SESSION_STORAGE_NEW_PAGE,
      value: 'true',
    });
    setStopScroll(false);
    let href;
    let asHref;
    const site = tenant;
    setBusy(true);
    let newTenant = tenant;
    const splitTenant = tenant.split('-');
    if (store && store !== 'tienda') {
      newTenant = `${storeMap[store]}-${splitTenant[1]}`;
    }
    if (newTenant === 'aldo-pe') {
      newTenant = 'aldoshoes-pe';
    }
    if (pageName === 'search') {
      const newUrl = url
        .replace(`/${newTenant}/${replacePathsToStandalonePaths(pageName, store)}?`, '')
        .replace(`/${newTenant}/${replacePathsToStandalonePaths(pageName, store)}/?`, '');
      href = `/${replacePathsToStandalonePaths(pageName, store)}?site=${site}&${newUrl}`;
      asHref = `/${store && store !== 'tienda' ? newTenant : site}/${replacePathsToStandalonePaths(pageName, store)}${
        newUrl ? `?${newUrl}` : ''
      }`;
    } else {
      const newPath = url.replace(`/${newTenant}/${replacePathsToStandalonePaths(pageName, store)}/`, '');
      const params = newPath.split('?');
      const splitUrl = params[0].split('/');
      const categoryId = splitUrl[0];
      const categoryName = splitUrl[1];
      if (pageName === 'shop') {
        href = `/${replacePathsToStandalonePaths(pageName, store)}?site=${tenant}&id=${categoryId}&${params[1]}`;
      } else {
        href = `/${replacePathsToStandalonePaths(
          pageName,
          store
        )}?site=${tenant}&id=${categoryId}&name=${categoryName}&${params[1]}`;
      }

      asHref = url;
    }
    Router.push(href, asHref);
  };

  const renderPaginationItem = (pageIndex, key, disabled = false) => {
    return (
      <>
        <button
          key={key}
          type="button"
          className={cx(
            'btn',
            'pagination-item',
            key === 'ACTIVE' && 'active',
            isTottusStandalone(store) && 'tottus',
            isWhitelabel({ store }) && 'whitelabel'
          )}
          id={`testId-pagination-${section}-button${pageIndex}`}
          onClick={() => {
            onPageSelection(getPaginatedUrl(pageIndex));
            resetDigitalData();
          }}
          disabled={disabled}
        >
          <Text fontWeight="bold">{pageIndex}</Text>
        </button>
        <style jsx>{styles}</style>
      </>
    );
  };

  const renderNeighborButtons = (type) => {
    const neighborCount = [1, totalPages].includes(currentPage) ? 2 : 1;
    let startIndex = 0;
    let endIndex = 0;

    if (type === 'LEFT') {
      startIndex = currentPage - neighborCount;
      startIndex = startIndex > 1 ? startIndex : 2;
      endIndex = currentPage - 1;
    }

    if (type === 'RIGHT') {
      startIndex = currentPage + 1;
      endIndex = currentPage + neighborCount;
    }

    const indexes = [];
    for (let i = startIndex; i <= endIndex && i < totalPages; i += 1) {
      indexes.push(i);
    }

    return indexes.map((e) => {
      return renderPaginationItem(e, `${type}${e}`);
    });
  };

  return (
    <HStack>
      <button
        id={`testId-pagination-${section}-arrow-left`}
        type="button"
        className="btn pagination-arrow"
        onClick={() => {
          onPageSelection(getPaginatedUrl(currentPage - 1));
        }}
        disabled={currentPage === 1}
      >
        <ChevronLeftIcon boxSize="20px" />
      </button>
      {currentPage !== 1 && renderPaginationItem(1, 'LEFT1')}
      {currentPage - 2 > 1 && totalPages > 4 && <span className="dots">...</span>}
      {renderNeighborButtons('LEFT', currentPage)}
      {renderPaginationItem(currentPage, 'ACTIVE')}
      {renderNeighborButtons('RIGHT', currentPage)}
      {totalPages - (currentPage + 1) > 1 && totalPages > 4 && <span className="dots">...</span>}
      {currentPage !== totalPages &&
        renderPaginationItem(totalPages, `RIGHT${totalPages}`, totalPages - (currentPage + 1) > 1 && totalPages > 4)}

      <button
        id={`testId-pagination-${section}-arrow-right`}
        type="button"
        className="btn pagination-arrow"
        onClick={() => {
          onPageSelection(getPaginatedUrl(currentPage + 1));
        }}
        disabled={currentPage === totalPages}
      >
        <ChevronRightIcon boxSize="20px" />
      </button>
      <style jsx>{styles}</style>
    </HStack>
  );
};

Pagination.propTypes = {
  getPaginatedUrl: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  resultsPerPage: PropTypes.number.isRequired,
  totalResults: PropTypes.number.isRequired,
  section: PropTypes.string,
  tenant: PropTypes.string.isRequired,
  setBusy: PropTypes.func.isRequired,
  pageName: PropTypes.string.isRequired,
  setStopScroll: PropTypes.func,
  store: PropTypes.string,
};

Pagination.defaultProps = {
  section: '',
  setStopScroll: noop,
  store: '',
};

export { Pagination };
